export const fixedValues = {
  smallInputWidth: '2.153rem',
  largeInputWidth: '3.153rem',
  separatorWidth: '0.538rem',
} as const;
